import { object, string } from "yup";
import { PASSWORD_RULE } from "./signupValidationSchema";

export const selfExclusionValidationSchema = object().shape({
    period: string().when("$configObj", ([config], schema) => {
        return schema.required(config.t("validation_err_required"));
    }),
    password: PASSWORD_RULE,
});
